export const T = {
  en_GB: {
    title: "Compliance",
    description: "Review and audit flow instances for compliance requirements",
    clientsReview: "Clients Review",
    clientsReviewDescription:
      "Screening standing per client, with the ones that need follow-up filtered out.",
    batchLookup: "PEP/Sanction Batch Lookup",
    batchLookupDescription: "Run batch PEP/Sanction screening on all clients in a view.",
    flowsReview: "Flows Review",
    flowsReviewDescription:
      "After-the-fact control of advice flows, with the compliance-relevant facts side by side.",
    flowApprovals: "Flow Approvals",
    flowApprovalsDescription:
      "Review, approve or reject flow instances waiting for compliance approval.",
    identityChanges: "Identity Changes",
    identityChangesDescription:
      "Who changed a client's name, national ID, country or date of birth — and from where.",
  },
  nb_NO: {
    title: "Compliance",
    description: "Gjennomgå og kontroller flytforekomster mot compliance-krav",
    clientsReview: "Kundegjennomgang",
    clientsReviewDescription:
      "Screeningstatus per kunde, med kundene som krever oppfølging filtrert ut.",
    batchLookup: "PEP/sanksjonssøk for flere kunder",
    batchLookupDescription: "Kjør PEP/sanksjonssøk på alle kunder i en visning.",
    flowsReview: "Flytgjennomgang",
    flowsReviewDescription:
      "Etterkontroll av rådgivningsflyter, med de compliance-relevante fakta side om side.",
    flowApprovals: "Flytgodkjenninger",
    flowApprovalsDescription:
      "Gjennomgå, godkjenn eller avvis flytforekomster som venter på compliance-godkjenning.",
    identityChanges: "Identitetsendringer",
    identityChangesDescription:
      "Hvem som endret kundens navn, fødselsnummer, land eller fødselsdato — og hvorfra.",
  },
} as const;
